import ArtifactGroupType from "../base/ArtifactGroupType";


const BloodlettingStingraySpine = {
  id: '147',
  name: 'Bloodletting Stingray Spine',
  groupIcon: 'UnderTheCeiba',
  type: ArtifactGroupType.UNDER_THE_CEIBA,
  icon: 'BloodlettingStingraySpine',
  power: 10,
  gameId: 'BloodlettingStingraySpine'
};

export default BloodlettingStingraySpine;
